// extracted by mini-css-extract-plugin
export default {"table":"Table_table__xePtl","table-header":"Table_table-header__fnFKl","table-header-title":"Table_table-header-title__2fX+X","table-header-date":"Table_table-header-date__eU36e"};